import { createUseStyles } from 'react-jss'
import { BRIGHT_GRAY } from '@omnilert/components'

const useStyles = createUseStyles({
  container: {
    backgroundColor: BRIGHT_GRAY,
    height: 20,
    position: 'relative',
    width: '100%'
  },
  bar: {
    backgroundColor: ({ strokeColor }) => `${strokeColor}`,
    bottom: 0,
    left: 0,
    position: 'absolute',
    top: 0,
    width: ({ progress }) => `${progress}%`,
    transition: '0.2s all linear'
  }
})

export default useStyles
